<div class="modal-header">
	<h3 class="modal-title" id="modal-title-id">{{LOCALIZATION.email}}</h3>
	<h5 class="modal-subtitle">
    	<span [innerHTML]="productGroup.title | safeHtml"></span>
    </h5>
</div>
<div class="modal-body">
    <form class="form-signin" >
        <div class="row" style="max-height:350px; overflow-y:auto; overflow-x:hidden; padding-bottom:16px;">
            <div class="col-md-12">
                <div class="item-hover pointMe" *ngFor="let email of input.emails">
                    <div class="row">
                        <div class="col-xs-1"><i (click)="removeEmail(email)" class="fa fa-times text-red"></i></div>
                        <div class="col-xs-10"><span title="{{email}}">{{email}}</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
            	<label for="emails">{{LOCALIZATION.email}}</label>
                <input id="emails" name="emails" type="text" [(ngModel)]='input.email' 
                    class="item-input" 
                	placeholder="{{LOCALIZATION.addEmail}}" 
                	(keyup.enter)="addEmail()"
                	autofocus aria-label="Email input field">
                <span (click)="addEmail()" style="display:inline-block" class="fa fa-plus accent-color" title="{{LOCALIZATION.addEmail}}"></span>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-6">
                <label for="file">{{LOCALIZATION.fileAttach}}</label>
                <div class="toggle-switch">
                    <input id="file" name="file" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="input.isFile">
                    <label for="file"></label>
                </div>
            </div>
            <div class="col-md-6">
                <label for="metadata">{{LOCALIZATION.metadataOptions}}</label>
                <div class="toggle-switch">
                    <input id="metadata" name="metadata" class="toggle-switch-toggle toggle-switch-toggle-round" type="checkbox" [(ngModel)]="input.allMetadata">
                    <label for="metadata"></label>
                </div>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-6" >
                <label for="format">{{LOCALIZATION.metadataFormat}}</label>
                <select class="form-control" [(ngModel)]="input.format" id="format" name="format">
                    <option value="txt">{{LOCALIZATION.txt}}</option>
                    <option value="csv">{{LOCALIZATION.csv}}</option>
                    <option value="html">{{LOCALIZATION.html}}</option>
                </select>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-12" >
                <label for="subject">{{LOCALIZATION.subject}} ({{LOCALIZATION.optional}})</label>
                <input id="subject" name="subject" type="text" [(ngModel)]="input.subject" maxlength="255" class="item-input" placeholder="Enter a subject">
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-md-12" >
                <label for="message">{{LOCALIZATION.message}} ({{LOCALIZATION.optional}})</label>
                <textarea id="message" name="message" [(ngModel)]="input.message" 
                	 (ngModelChange)="onUserChars($event)"
                	 maxlength="{{userInput.limit}}"
                	 class="item-input" placeholder="{{LOCALIZATION.enterMessage}}" 
                	 style="margin: 0px; width: 300px; height: 150px; border: 1px solid #9e9e9e;"></textarea>
				<span class="help-block pull-right">{{userInput.chars}}/{{userInput.limit}}</span>                	 
            </div>
        </div>        
    </form>
</div>
<div class="modal-footer">
	<button class="btn btn-default" type="button" (click)="close()">{{LOCALIZATION.cancel}}</button>
    <button class="btn btn-primary" type="button" (click)="send()">{{LOCALIZATION.send}}</button>
</div>